import * as R from 'ramda';
import Vue from 'vue';
import { loginUserModule } from '@/store/modules/LoginUserStore';

const PermissionPlugin = {
  install(vue: typeof Vue) {
    vue.prototype.$hasPermission = (permissionKey: string): boolean => {
      const permissions = loginUserModule.userPermissions;
      if (!permissions) {
        return false;
      }
      // ドット区切りのキーをパスの配列に変換
      const path = permissionKey.split('.');
      // Ramdaのpath関数でネストしたオブジェクトの値を取得
      return R.path(path, permissions) === true;
    };
  },
};

export default PermissionPlugin;
